import {AbstractPicker, IPickerOptions} from "./AbstractPicker";
import {convertFromServerString} from "../../util/datetime";
import {INPUT_DATE_FORMAT} from "../../constants";
import dateHtml from './date.html?raw';

export let template: string = dateHtml;

export class viewModel extends AbstractPicker<string> {

    constructor(options: IPickerOptions<string>) {
        super(options);
        const val = options.value?.()
        if (val) {
            const datestring = convertFromServerString(val).format(INPUT_DATE_FORMAT)
            this.observable(datestring)
        }
    }

}